import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import Form from '../settings/Form'
import { present } from '../settings/Form/validators'

import AutoCompleteLeads from '../../../util/auto_complete/Leads'

@inject('websites', 'recommended_listings')
@observer
export default class AddRecommendedListing extends Component {
  website = this.props.websites.current

  handleData = data => {
    return this.props.recommended_listings.create(data).then(newRecListings => {
      this.props.router.push({
        pathname: `/website/${this.website.id}/recommended/listings`,
        state: { highlight: newRecListings.map(rl => rl.id) }
      })
    })
  }

  returnToState() {
    const selected = {}
    if (this.mls_numbers.value) selected.mls_numbers = this.mls_numbers.value
    return { ...this.getDefaults(), ...selected }
  }

  createLead = () => {
    const { router } = this.props
    router.replace({
      pathname: `/website/${this.website.id}/leads/invite`,
      state: { return_to: { ...router.location, state: this.returnToState() } }
    })
  }

  getDefaults() {
    const { state={}, query } = this.props.location
    return { ...state, ...query }
  }

  render() {
    const validations = [
      { field: 'lead_id', validate: present, message: 'Please select a Lead' },
      { field: 'mls_numbers', validate: present, message: 'Please select a Search' }
    ]
    const defaults = this.getDefaults()
    return (
      <div className="container centered padded recommended-listings">
        <Form className="full" onData={this.handleData} validations={validations}>
          <div className="panel padded">
            <h2 className="title">Listing Recommendation</h2>

            <div className="form-section">
              <label>Select a Lead</label>
              <p className="muted">This lead will receive the recommended listing.</p>
              <AutoCompleteLeads
                name="lead_id"
                selected={defaults.lead_id}
                onCreateNew={this.createLead} />
            </div>

            <div className="form-section">
              <label>Add MLS Number(s)</label>
              <p className="muted">When adding multiple listings, separate each MLS number with a space.</p>
              <textarea ref={el => this.mls_numbers = el} name="mls_numbers" defaultValue={defaults.mls_numbers} />
            </div>

          </div>
          <button type="submit" className="big shadowed">Send Recommended Listing</button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/RecommendedListings/Add.js